import React from 'react';
import { Link } from 'react-router-dom';

import MetaCheckbox from '../../components/MetaCheckbox';

const renderAmount = amount =>
  amount !== null ? `£${amount.toFixed(2)}` : 'N/A';

export const PLANS_TABLE_COLUMNS = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    render: id => <Link to={`/admin/plans/${id}`}>#{id}</Link>,
  },
  {
    title: 'Status',
    dataIndex: 'cancelled',
    key: 'cancelled',
    render: cancelled => (cancelled ? 'Cancelled' : 'Active'),
  },
  {
    title: 'Contract number',
    dataIndex: 'contractNumber',
    key: 'contractNumber',
  },
  {
    title: 'VRN',
    dataIndex: 'VRN',
    key: 'VRN',
  },
  {
    title: 'Driver name',
    dataIndex: 'Customer.id',
    key: 'CustomerId',
    render: (_, { Customer: customer }) =>
      customer.firstName || customer.lastName
        ? `${customer.firstName} ${customer.lastName}`
        : 'Not specified',
  },
];

export const CANCELLED_PLANS_TABLE_COLUMNS = [
  ...PLANS_TABLE_COLUMNS,
  {
    title: 'Components Price',
    dataIndex: 'fullComponentsPrice',
    render: renderAmount,
  },
  {
    title: 'Cash balance',
    dataIndex: 'cashBalance',
    key: 'cashBalance',
    render: renderAmount,
  },
  {
    title: 'DD Cancelled',
    dataIndex: 'PlanCancellation.isDirectDebitCancelled',
    key: 'isDirectDebitCancelled',
    align: 'center',
    render: (checked, { id }) => (
      <MetaCheckbox
        checked={checked}
        name="isDirectDebitCancelled"
        planId={id}
      />
    ),
  },
  {
    title: 'Refunded',
    dataIndex: 'PlanCancellation.isRefunded',
    key: 'isRefunded',
    align: 'center',
    render: (checked, { id }) => (
      <MetaCheckbox checked={checked} name="isRefunded" planId={id} />
    ),
  },
];
